import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD_DGMEzsWsWiSV0JALDDdyIIxczMR119w",
  authDomain: "kaana-b0fc7.firebaseapp.com",
  projectId: "kaana-b0fc7",
  storageBucket: "kaana-b0fc7.firebasestorage.app",
  messagingSenderId: "201234528041",
  appId: "1:201234528041:web:8e76f12608664daab1e938",
  measurementId: "G-DGPEMEV3XW"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let analytics;
if (typeof window !== "undefined") {
  isSupported()
    .then(supported => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(error => {
      console.error("Analytics initialization failed:", error);
    });
}

export { app, auth, analytics };

